<template>

    <BaseForm ref="form" @submitted="submit()">

        <LoadingOverlay :loading="loading">
                
            <div class="grid gap-6 mb-6">

                <BaseInputGroup label="Name" :error="form?.error('name')">
                    <BaseInput v-model="payload.name"/>
                </BaseInputGroup>

            </div>

            <BaseButton :disabled="submitting" :loading="submitting">
                {{ $t(action) }}
            </BaseButton>

        </LoadingOverlay>

    </BaseForm>

</template>

<script setup>
    import { useI18n } from '@/composables/i18n'
    import { useModelForm } from '@/composables/model-ui'
    import { useSectorStore } from '@/store/model'

    const { t } = useI18n()
    const store = useSectorStore()
        
    const { form, id, payload, loading, submitting, create, edit, submit, mode } = useModelForm({ 
        store: store, 
        messages: {
            created: t('message.sector-created'),
            updated: t('message.sector-updated'),
            destroyed: t('message.sector-destroyed')
        }
    })

    const action = computed(() => id.value  ? 'labels.submit-sector-edit' : 'labels.submit-sector-create')

    defineExpose({ mode, create, edit })
</script>
